<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <div>
          <div class="row">
            <div class="col-sm-6">
              <h4 class="card-title">
                Edit Address Book Entry
              </h4>
            </div>
            <div class="col-md-6  m-b-0 text-right">
              <button class="btn btn-sm btn-secondary waves-effect waves-light text-white" @click="back()">
                <i class="fas fa-arrow-left" />&nbsp; Back
              </button>
            </div>
          </div>
          <div v-if="entry" class="row mt-3">
            <div class="col-sm-12">
              <div class="card">
                <form class="form-horizontal" @submit.prevent="handleSubmit">
                  <div class="card-body card-blue">
                    <div class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="public_key">Address
                        Type
                      </label>
                      <div class="col-sm-5">
                        <input id="addr_type" v-model="entry.address_type" class="form-control" data-vv-as="Name" name="addr_type" placeholder="Entry Name" readonly type="text">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="name">Entry Name
                        <span class="required text-danger">*</span>
                      </label>
                      <div class="col-sm-5">
                        <input id="name" v-model="entry.name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('name')}" class="form-control" data-vv-as="Name" name="name" placeholder="Entry Name" type="text">
                        <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                          {{ errors.first('name') }}
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="description">Description</label>
                      <div class="col-sm-5">
                        <input id="description" v-model="entry.description" :class="{'is-invalid': submitted && errors.has('description')}" class="form-control" data-vv-as="Description" name="description" placeholder="Description" type="text">
                        <div v-if="submitted && errors.has('description')" class="invalid-feedback">
                          {{ errors.first('description') }}
                        </div>
                      </div>
                    </div>

                    <div v-if="entry.address_type=='Group' || entry.address_type=='Account' " class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="public_key">Public Key
                      </label>
                      <div class="col-sm-5">
                        <input id="public_key" v-model="entry.public_key" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('public_key')}" class="form-control" data-vv-as="Public Key" name="public_key" placeholder="Public Key" readonly type="text">
                        <div v-if="submitted && errors.has('public_key')" class="invalid-feedback">
                          {{ errors.first('public_key') }}
                        </div>
                      </div>
                    </div>

                    <div v-if="entry.address_type=='Group'" class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="group_id">Group ID </label>
                      <div class="col-sm-5">
                        <input id="group_id" v-model="entry.group_id" class="form-control" name="group_id" placeholder="Group ID" readonly type="number">
                      </div>
                    </div>

                    <div v-if="entry.address_type=='Did'" class="form-group row">
                      <label class="col-sm-3 text-right control-label col-form-label" for="group_id">DID</label>
                      <div class="col-sm-5">
                        <input id="did" v-model="entry.did" class="form-control" name="did" placeholder="DID" readonly type="text">
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                      <div class="button-group">
                        <button :disabled="submitted" class="btn waves-effect waves-light btn-success" type="submit">
                          Save
                        </button>
                        <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'AddressBookEdit',
  props: ['addressbookid'],
  data () {
    return {
      submitted: false,
      entry: null
    }
  },
  computed: {
    ...mapGetters(['userAddressBook', 'userAddressBookItemById'])
  },
  beforeMount () {
    this.init()
  },
  mounted () {

  },
  methods: {
    async init () {
      this.entry = JSON.parse(JSON.stringify(this.userAddressBookItemById(this.addressbookid)))
    },

    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.update()
          } else {
            this.submitted = false
          }
        })
    },
    async update () {
      try {
        await this.$accounts.patch(`/addressbook/${this.addressbookid}/user`, this.entry)
        this.$toastr.s('Address Book Entry updated', 'Success!')

        const indexOfItem = this.userAddressBook.findIndex(item => item.address_book_entry == this.addressbookid)
        Vue.set(this.userAddressBook, indexOfItem, this.entry)

        await this.$router.push({ name: 'address-book-entries' })
      } catch (e) {
        console.log(e)
        this.$toastr.e('Address Book Entry update failed', 'Failed!')
      }
    },
    async reset () {
      await this.init()
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>
